import { createGetChannel } from '../utils/apis/requestRX';
import { Fetch, ResponseData } from '../utils/apis/typeRX';

export interface checkTokenParams {
    token: string | null;
}

export const checkToken: Fetch<checkTokenParams, ResponseData<any>> = createGetChannel('/api/reexuan-blockchain-service/explorer/checkToken');